import * as React from 'react'

export type ProgressProps = React.ComponentPropsWithoutRef<'div'> & {
  value?: number
}

export const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ value = 0, className = '', ...props }, ref) => {
    const clamped = Math.max(0, Math.min(100, value))
    return (
      <div
        ref={ref}
        className={`relative h-2 w-full overflow-hidden rounded bg-[#3D3833] dark:bg-[#292524] ${className}`}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={clamped}
        role="progressbar"
        {...props}
      >
        <div
          className="h-full bg-[#C2714F] transition-all dark:bg-[#D4825F]"
          style={{ width: `${clamped}%` }}
        />
      </div>
    )
  }
)

Progress.displayName = 'Progress'